<script>
    /*
    	ExplorerServiceListItem.svelte

        New index fields as of 11/15/22 (note that some field names differ from service records)

        address-line-1: "1520 Market Street"
        average-rating: 0
        city: "St. Louis"
        distance: 0.7927880061922868
        distanceUnit: "mi"
        exclusive-requirements: []
        main-email: "amanda@fccouncil.net"
        main-phone: "3192347600"
        main-website: "www.stlouis-mo.gov/government/departments/human-services/aging-services/index.cfm"
        num-ratings: 0
        postal-code: "63103"
        preferred-partner: 0
        score: 1
        service-description: "Family & Children’s Council of Black Hawk County is to strengthen families and educate our community in the prevention of child abuse in Black Hawk County."
        service-id: "1"
        service-location: {lat: 38.6278174, lon: -90.20314719999999}
        service-name: "st. louis AAA"
        state: "Missouri"
        taxonomies: {demographics: Array(4), open-eligibility-2022: Array(13), tcare-taxonomy-1: Array(10)}        
    
    */

    import { onMount } from 'svelte';
    import { fade } from 'svelte/transition';

    import { masterService } from '../../common/master-objects.js';
    import { formatPhoneNumber } from "../../common/utils.js";
    import { level0Node, level1Node, level2Node, level3Node, level4Node } from '../../stores/ResourceMenuStore.js';
	import { currentListItemId } from '../../stores/ScreenSettingsStore';
    import { push } from 'svelte-spa-router';
    import { setWarningAlert, setErrorAlert, setInfoAlert } from '../../stores/AlertsStore';
    import { addSavedServices } from '../../api/services.js';
    import { AccountStore } from "../../common/account.ts";
    import Tooltip, { Wrapper } from '@smui/tooltip';
    import Button, { Label } from '@smui/button';


    // TCARE components
    const SVG_CONNECT_PATH   = '/svg-icons/button-icons/molecular-1.svg';
    import TCareRatingStars from '../tcare-ui/TCareRatingStars.svelte';
    import SaveResourceButton from '../buttons/SaveResourceButton.svelte';
    import MoreInfoButton from '../buttons/MoreInfoButton.svelte';

    
    const NOT_AVALABLE = "not available";
    const PREFERRED_BADGE_PATH = '/img/preferred_badge.png';

    $: formattedService = formatServiceFields(service);
    $: borderStyle = getBorderStyle(formattedService);
    $: isShowingMoreInfo = false;

    export let service;
    export let onShowPopup;
    

    onMount(() => {
        // console.log('ExplorerServiceListItem onMount');
        // console.log(service);
    })

    // must check for nulls
    const formatServiceFields = (service) => {
        let svc = {};
        svc.name = service['service-name'] ? service['service-name'] : '';
        svc.avgRating = service['average-rating'] ? service['average-rating'] : '';
        svc.numRatings = service['num-ratings'];
        svc.distance = formatDistance(service);
        svc.address1 = service['address-line-1'] ? service['address-line-1'] : '';
        svc.cityStateZip = formatCityStateZip(service);

        // phone = service['main-phone'] ? service['main-phone'] : '';
        svc.phone = formatPhoneNumber(service['main-phone']);               // utils.js
        svc.email = service['main-email'] ? service['main-email'] : '';
        svc.website = service['main-website'] ? service['main-website'] : '';

        svc.description = service['service-description'] ? service['service-description'] : '';
        if (svc.description.length < 3) svc.description = 'Description not available.';

        svc.isPreferred = service['preferred-partner'] ? service['preferred-partner'] > 0 : false;

        //filters = ['Food Delivery', 'Food Pantry', 'Bulk Transport'];
        return svc;
    }

    const formatDistance = (service) => {
        if (!service['distance'] || !service['distanceUnit']) return '';
        let dist = service['distance'].toFixed(1);
        return dist + ' ' + service['distanceUnit'];
    }

    const formatCityStateZip = (service) => {
        let city = service['city'] ? service['city'] : '';
        let state = service['state'] ? service['state'] : '';
        let zip = service['postal-code'] ? service['postal-code'] : '';
        if (city !== '') {
            return city + ', ' + state + ' ' + zip;
        } else {
            return state + ' ' + zip;
        }
    }

    const getBorderStyle = (service) => {
        if (!service.isPreferred) return '';
        return 'border-left: 2px solid #FE4672; border-top-left-radius: 0px; border-bottom-left-radius: 0px';
    }
    

    const onMoreInfoButtonClick = () => {
        isShowingMoreInfo = !isShowingMoreInfo;
    }

    const onSaveResourceButtonClick = () => {
        onSaveResource();
    }

    const onSaveResource = async () => {
        if (!$AccountStore?.isLoggedIn) {
            setWarningAlert('You must be logged in to save a resource', 2000);
            return;
        }

        let serviceId = parseInt(service['service-id']);
        if (isNaN(serviceId)) {
            setWarningAlert('Cannot save resource - invalid Service ID', 2000);
            return;
        }

        const json = await addSavedServices([serviceId]);          // services.ts - must pass array

        if (json.errors) {
            setWarningAlert('Error while saving resource', 2000);
        } else {
            onShowPopup();
            // setInfoAlert('Resource saved to My Services', 2000);
        }
    }

    // old Referrals flow - may need to reference this in the future
    /*
        if (!service) return;
        $currentListItemId = service['service-id'];
        // update masterService store on any click
        $masterService.clearApiData();
        $masterService.copyApiDataFrom(service);
        $masterService = $masterService;                // refresh the store
        push('/referrals');
    */

    const sanitizeWeblink = (link) =>  {
        let sanitized = { link: "", ok: false};
        if (!link || link.length < 3) return sanitized;

        try {
            let url = new URL(link);
            sanitized.link = url.toString();
            sanitized.ok = true;
            return sanitized;
        } catch (error) {
           // continue
        }

        // check for scheme
        let matches = link.match(/^([a-z0-9]+):\/\//);
        if (matches === null || matches.length === 0){
            sanitized.link = "http://" + link;
            sanitized.ok = true;
            return sanitized;
        }

        // TODO: more checks?

        sanitized.link = link;
        return sanitized
    }


    const launchWebSite = (link) => {
        let sanitized = sanitizeWeblink(link)
        if (!sanitized.ok) {
            setWarningAlert('This web link is not in a valid format', 2000);
            return;
        }
        window.open(sanitized.link, "_blank") || window.location.replace(sanitized.link);
    }

    const launchEmail = (link) => {
        //alert('launchEmail: ' + link);
        let href = 'mailto:' + link;
        window.open(href, "_blank") || window.location.replace(href);
    }

    const _onConnectClick = () => {
        $currentListItemId = service['service-id'];
        // update masterService store on any click
        if (service) {
            $masterService.clearApiData();
            $masterService.copyApiDataFrom(service);
            $masterService = $masterService;                // refresh the store
        }
        push('/referrals');
    }

</script>

<style>
    .service-list-item {
        position: relative;
        width: 89%;
        padding: 20px 30px 20px 40px;
        margin-bottom: 10px;
        font-size: 14px;
        color: var(--tcui-primary);
        background: #F8F3F8;
        border-radius: 25px;
    }


    .service-list-item .top {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        margin-bottom: 0px;
    }

    .service-list-item .middle {
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        margin-bottom: 0px;
    }

    .service-list-item .bottom {
        margin-top: 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .service-list-item .left {
        width: 50%;
        height: 75px;
        /* border: 1px solid green; */
    }
    
    .service-list-item .right {
        width: 50%;
        height: 75px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        /* border: 1px solid green; */
    }
    
    .service-list-item .h-10 {
        height: 10px;
    }

    .service-list-item .w-15 {
        width: 15px;
    }

    .service-list-item .icon {
        width: 18px;
        height: 18px;
        margin-right: 10px;
        /* border: 1px solid green; */
    }


    /* FIELD FORMATTING */
    .service-list-item .name {
        font-size: 16px;
        font-weight: 800;
        /* text-decoration: underline; */
    }
    
    .service-list-item .row {
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    
    .service-list-item .phone {
        width: 275px;
        user-select: none;
    }
    
    .service-list-item .email {
        width: 275px;
        cursor: pointer;
        text-decoration: underline;
    }

    .service-list-item .email:hover {
        color: var(--tcui-secondary);
    }

    .service-list-item .web {
        width: 275px;
        cursor: pointer;
        text-decoration: underline;
    }

    .service-list-item .web:hover {
        color: var(--tcui-secondary);
    }
    
    /*
    .service-list-item .distance-box {
        width: 40px;
        height: 40px;
        margin-right: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
    }

    .service-list-item .distance {
        font-size: 9px;
        font-weight: 700;
    }
    */

    .service-list-item .address {
        height: 40px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: space-between;
    }

    .service-list-item .badges {
        font-size: 10px;
        color: var(--tcui-primary);
        /* border: 1px solid red; */
    }

    .service-list-item .badge {
        min-width: 40px;
        padding: 5px 10px;
        margin-left: 8px;
        text-align: center;
        font-size: 11px;
        color: var(--tcui-dark-purple);
        background-color: white;
        border-radius: 15px;
    }

    :global(.service-list-item .learn-more) {
        width: 95% !important;
    }

    /* top right corner */
    .preferred-badge {
        position: absolute;
        top: 10px;
        right: 12px;
    }

    .service-list-item .more-info {
        width: 90%;
        padding: 3% 5%;
        user-select: none;
        background: #FFF4F7;
        border: 1px solid #FE6A8B;
        border-radius: 25px;    
    }

    .service-list-item .descr-title {
        margin-bottom: 15px;
        color: var(--tcui-secondary);
        font-size: 18px;
    }
    
    .service-list-item .descr-text {
        color: var(--tcui-primary);
        font-size: 12px;
    }
    

    
    

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<!-- <div class="service-list-item" in:fade="{{ duration: 150 }}" out:fade="{{ duration: 150 }}"> -->
<div class="service-list-item" style={borderStyle}>
    {#if formattedService.isPreferred}
        <div class="preferred-badge">
            <img class="svg-connect" src={PREFERRED_BADGE_PATH} alt={'Preferred Partner'} draggable="false" >
        </div>
    {/if}

    <div class="top">
        <div class="row">
            <div class="name ellipsis">{formattedService.name}</div>
        </div>
        <div class="row">
            <TCareRatingStars 
                source={formattedService} 
                prop={'avgRating'} 
                setValue={null}
                isReadOnly={true}
                starColor={'#611C73'}
            />
            {#if formattedService.numRatings !== '' && formattedService.numRatings !== 0}
                &nbsp; ({formattedService.numRatings})
            {/if}
        </div>
    </div>

    <div class="h-10" />

    <div class="middle">
        <div class="left">
            <div class="row">
                <div class="h-10" />
            </div>
            <div class="row">
                <div class="address">
                    <div>{formattedService.address1}</div>
                    <div>{formattedService.cityStateZip}</div>
                </div>
            </div>
        </div>

        <div class="right">
            <div class="row">
                <div class="icon"><img src='/img/phone-call.png' alt='Pin' draggable="false"/></div>
                {#if formattedService.phone.length > 2}
                    <div class="phone">{formattedService.phone}</div>
                {:else}
                    <div class="phone">Phone {NOT_AVALABLE}</div>
                {/if}
            </div>

            <div class="h-10" />

            <div class="row" on:click={() => launchEmail(formattedService.email)}>
                <div class="icon"><img src='/img/mail.png' alt='Pin' draggable="false"/></div>
                {#if formattedService.email.length > 2}
                    <div class="email ellipsis">{formattedService.email}</div>
                {:else}
                    <div class="phone">Email {NOT_AVALABLE}</div>
                {/if}
            </div>

            <div class="h-10" />

            <Wrapper>
                <div class="row" on:click={() => launchWebSite(formattedService.website)}>
                    <div class="icon"><img src='/img/web.png' alt='Pin' draggable="false"/></div>
                    {#if formattedService.website.length > 2}
                        <div class="web ellipsis">{formattedService.website}</div>
                        <Tooltip xPos="start" yPos="above">{formattedService.website}</Tooltip>
                    {:else}
                        <div class="phone">Website {NOT_AVALABLE}</div>
                    {/if}
                </div>
            </Wrapper>

        </div>
    </div>

    <div class="bottom">
        <div class="row badges">
            <!-- FILTER BADGES -->
            {#if $level0Node} <div class="badge">{$level0Node.label}</div> {/if}
            {#if $level1Node} <div class="badge">{$level1Node.label}</div> {/if}
            {#if $level2Node} <div class="badge">{$level2Node.label}</div> {/if}
            {#if $level3Node} <div class="badge">{$level3Node.label}</div> {/if}
            {#if $level4Node} <div class="badge">{$level4Node.label}</div> {/if}
        </div>
        <div class="row">
            <MoreInfoButton onClick={onMoreInfoButtonClick} />
            <div class="w-15"></div>
            <SaveResourceButton onClick={onSaveResourceButtonClick} />
        </div>
    </div>

    {#if isShowingMoreInfo}
        <div class="h-20" />
        <div class="more-info">
            <div class="descr-title">Description</div>
            <div class="descr-text">{formattedService.description}</div>
        </div>
    {/if}

</div>

